import React, { useState, useEffect } from "react";
import "../assets/css/AñadirParametros.css";
import { useNavigate } from "react-router-dom";
import Layout from "./Layout";
import { getUpdateData, createParametro } from "../services/API";
import socket from "../assets/js/socket";
import axios from "axios";
import alertify from "alertifyjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlay } from "@fortawesome/free-solid-svg-icons";
import "alertifyjs/build/css/alertify.css";
import "alertifyjs/build/css/themes/default.css";
import 'bootstrap/dist/css/bootstrap.min.css';

const AddParameters = () => {
    const [selectedSection, setSelectedSection] = useState("RISK");
    const [selectedFunction, setSelectedFunction] = useState("Select");
    const [, setShowDropdown] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [tituloInformacion, setTituloInformacion] = useState("");
    const [dataAdgroups, setDataAdgroups] = useState([]);
    const [dataCampaign, setDataCampaign] = useState([]);
    const [dataPortfolios, setDataPortfolios] = useState([]);
    const [dataProductos, setDataProductos] = useState([]);
    const [copiesRealTime, setCopiesRealTime] = useState({});
    const navigate = useNavigate();
    const [reglas, setReglas] = useState([]);
    const [selectedCampaignType, setSelectedCampaignType] = useState("SP");
    const [searchText, setSearchText] = useState("");
    const [statusFilter, setStatusFilter] = useState("ALL");

    const handleFilterClick = (filtro) => {
        setStatusFilter(filtro);
    };

    const getDataRealTime = (response) => {
        const campaigns = response.data.campaigns
            .filter(campaign => campaign.state !== "ARCHIVED")
            .map(campaign => ({
                ...campaign,
                adGroups: (campaign.adGroups || []).filter(group => group.state !== "ARCHIVED")
            }));

        const productos = response.data.productos.map(producto => ({
            ...producto,
            campaigns: producto.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(producto => producto.campaigns.length > 0 && producto.state !== "ARCHIVED")

        const portafolios = response.data.portfolios.map(portafolio => ({
            ...portafolio,
            campaigns: portafolio.campaigns.filter(campaign => campaign.state !== "ARCHIVED")
        }))
            .filter(portafolio => portafolio.campaigns.length > 0 && portafolio.state !== "ARCHIVED")

        const asinMap = new Map();

        productos.forEach(producto => {
            const { asin, campaigns = [] } = producto;

            if (!asinMap.has(asin)) {
                asinMap.set(asin, { ...producto, campaigns: [...campaigns] });
            }
            else {
                const existente = asinMap.get(asin);
                const campaignIdsExistentes = new Set(existente.campaigns.map(c => c.campaignId));
                campaigns.forEach(campaign => {
                    if (!campaignIdsExistentes.has(campaign.campaignId)) {
                        existente.campaigns.push(campaign);
                        campaignIdsExistentes.add(campaign.campaignId);
                    }
                });
                asinMap.set(asin, existente);
            }
        });

        const resultadoFinal = Array.from(asinMap.values());

        setDataAdgroups(campaigns);
        setDataProductos(resultadoFinal);
        setDataCampaign(campaigns);
        setDataPortfolios(portafolios);
        setCopiesRealTime({
            adgroups: campaigns,
            campaigns: campaigns,
            portafolios: portafolios,
            productos: resultadoFinal
        });
    }

    useEffect(() => {
        (async () => {
            const accountID = localStorage.getItem("selectedAccountValue");
            const response = await getUpdateData(accountID);
            console.log(response);

            getDataRealTime(response);
        })();
    }, [setDataAdgroups, setDataCampaign, setDataPortfolios, setCopiesRealTime, setDataProductos]);

    useEffect(() => {
        if (selectedFunction === "Campaigns")
            setDataCampaign(copiesRealTime.campaigns.filter(c => c.type === selectedCampaignType));
    }, [selectedCampaignType, selectedFunction, copiesRealTime]);


    const notifyBOT = async () => {
        await axios.get("https://bot.jungleclick.online");
        console.log("BOT notified.");
    }

    useEffect(() => {
        const handleConnect = () => {
            console.log("OK Connected to WebSocket server:", socket.id);
            notifyBOT();
        };

        const handleUpdate = (data) => {
            console.log("UPDATE Update received:", data);
            const account = localStorage.getItem("selectedAccountValue")
            if (data.data.accountId == account)
                getDataRealTime(data.data.data);
            else
                console.log("Update skipped");
        };

        socket.on("connect", handleConnect);
        socket.on("update", handleUpdate);

        return () => {
            socket.off("connect", handleConnect);
            socket.off("update", handleUpdate);
        };
    }, []);

    const handleDeleteRegla = (id) => {
        alertify.confirm("Delete", "Do you want to delete this rule", () => {
            setReglas((prev) => prev.filter((r) => r.id !== id));
        }, () => alertify.error("Operation cancelled"));
    };

    const [checkboxes, setCheckboxes] = useState({});
    const [isOpen, setIsOpen] = useState({});
    const [showSaveModal, setShowSaveModal] = useState(false);
    const [showCancelModal, setShowCancelModal] = useState(false);

    const generarDestiny = (data, tipo) => {
        if (Object.keys(checkboxes).length === 0)
            return "No destination has been selected.";
        const idsSelectdos = Object.keys(checkboxes).filter(id => checkboxes[id]);
        const portafolios = copiesRealTime.portafolios;
        const campanas = copiesRealTime.campaigns;
        const dataProductos = copiesRealTime.productos;
        if (idsSelectdos.length === 0)
            return "No destination has been selected.";
        else {
            switch (tipo) {
                case "Adgroups":
                    const campaignsFormateadas = [];
                    for (const campaign of campanas) {
                        const adGroupsFiltrados = campaign.adGroups.filter(ad => idsSelectdos.includes(ad.adGroupId));

                        if (adGroupsFiltrados && adGroupsFiltrados.length > 0) {
                            campaignsFormateadas.push({
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: adGroupsFiltrados.map(ad => ({
                                    adGroupId: ad.adGroupId,
                                    adGroupName: ad.name
                                }))
                            });
                        }
                    }
                    data.destinations = { campaigns: campaignsFormateadas };
                    break;
                case "Campaigns":
                    const campaignsSelectdas = [];
                    for (const campaign of campanas) {
                        if (idsSelectdos.includes(campaign.campaignId)) {
                            campaignsSelectdas.push({
                                campaignId: campaign.campaignId,
                                campaignName: campaign.name,
                                type: campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                adGroups: campaign.adGroups.map(ad => ({
                                    adGroupId: ad.adGroupId,
                                    adGroupName: ad.name
                                })) || []
                            });
                        }
                    }
                    data.destinations = { campaigns: campaignsSelectdas };
                    break;
                case "Portfolios":
                    const portfoliosFormateados = [];
                    for (const portfolio of portafolios) {
                        if (idsSelectdos.includes(portfolio.portfolioId)) {
                            const campaignsFormateadas = campanas
                                .filter(campaign => campaign.portfolioId === portfolio.portfolioId)
                                .map(campaign => ({
                                    campaignId: campaign.campaignId,
                                    campaignName: campaign.name,
                                    Type: campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                    adGroups: (campaign.adGroups || []).map(ad => ({
                                        adGroupId: ad.adGroupId,
                                        adGroupName: ad.name
                                    }))
                                }));
                            portfoliosFormateados.push({
                                portfolioId: portfolio.portfolioId,
                                portfolioName: portfolio.name,
                                campaigns: campaignsFormateadas
                            });
                        }
                    }
                    data.destinations = { portfolios: portfoliosFormateados };
                    break;
                case "Asins":
                    const productosFormateados = [];
                    for (const producto of dataProductos) {
                        if (idsSelectdos.includes(producto.adId)) {
                            const campaign = campanas.find(c => c.campaignId === producto.campaignId);
                            const adGroup = campaign.adGroups.find(ad => ad.adGroupId === producto.adGroupId);
                            const campaignFormateada = campaign
                                ? {
                                    campaignId: campaign.campaignId,
                                    campaignName: campaign.name,
                                    type: campaign.type === "SP" ? "Sponsored Products" : campaign.type === "SB" ? "Sponsored Brands" : campaign.type,
                                    adGroups: adGroup
                                        ? [{
                                            adGroupId: adGroup.adGroupId,
                                            adGroupName: adGroup.name
                                        }]
                                        : []
                                }
                                : null;
                            productosFormateados.push({
                                asin: producto.asin,
                                sku: producto.sku,
                                state: producto.state,
                                campaigns: campaignFormateada ? [campaignFormateada] : []
                            });
                        }
                    }
                    data.destinations = { asins: productosFormateados };
                    break;
                default:
                    break;
            }
            return "";
        }
    };

    const handleSave = async () => {
        setShowSaveModal(false);
        for (const regla of reglas) {
            if ((!regla.tipoRegla || !regla.configuracion) || (regla.tipoRegla === "Numeric" && !regla.range) || (regla.tipoRegla === "Textual" && regla.campoTexto.trim() === "")) {
                alertify.notify("Please complete all fields for each rule.", "error", 5);
                return;
            }
        }
        const recogerDatosFormulario = () => {
            const datos = {
                type: selectedCampaignType === "SP" ? 1 : 2,
                destino: selectedFunction,
                seccion: selectedSection,
                nombreParametro: document.getElementById("name_new_item").value,
                reglas: reglas.map((regla) => {
                    if (regla.tipoRegla === "Textual") {
                        return {
                            tipoRegla: regla.tipoRegla,
                            configuracion: regla.configuracion,
                            text: regla.campoTexto
                        };
                    } else if (regla.tipoRegla === "Numeric") {
                        return {
                            tipoRegla: regla.tipoRegla,
                            configuracion: regla.configuracion,
                            number: parseFloat(regla.campoTexto),
                            range: regla.range
                        };
                    } else {
                        return {};
                    }
                })
            };

            if (!datos.destino || !datos.seccion) {
                alertify.notify("Destination and Section fields are required.", "error", 5);
                return null;
            }

            const construirRules = (datos, operadores) => {
                const reglas = datos.reglas;
                const rules = [];
                reglas.forEach((regla, index) => {
                    const rule = {
                        name: "R" + (index + 1),
                        type: regla.tipoRegla,
                        configuration: regla.configuracion
                    };

                    if (regla.tipoRegla === "Textual") {
                        rule.text = regla.text;
                    } else if (regla.tipoRegla === "Numeric") {
                        rule.number = regla.number;
                        rule.range = regla.range;
                    }
                    rules.push(rule);
                    if (index < operadores.length) {
                        rules.push({
                            operator: operadores[index].toUpperCase()
                        });
                    }
                });
                return rules;
            };
            let operadores = reglas.map(regla => regla.operador).filter(operador => operador !== "");
            datos.rules = construirRules(datos, operadores);
            return datos;
        }

        const data = recogerDatosFormulario();
        if (!data) return;

        const errorMessage = generarDestiny(data, selectedFunction);
        if (errorMessage !== "") {
            alertify.notify(errorMessage, "error", 5);
            return;
        }
        const accountID = localStorage.getItem("selectedAccountValue");
        const response = await createParametro(data, accountID);
        (response.error) ? alertify.notify(response.error, "error", 5) : alertify.notify("Parameter created. Redirecting...", "success", 5);
        setTimeout(() => navigate("/parametros"), 2000);
    };

    const handleCancel = () => navigate("/parametros");

    const actualizarRegla = (id, campo, valor) => {
        setReglas((prev) =>
            prev.map((r) => (r.id === id ? { ...r, [campo] : valor } : r))
        );
    };

    const giveNewID = () => {
        let find = false;
        let Id = 1;
        while (!find) {
            if (reglas.filter((regla) => regla.id === Id).length === 0) find = true;
            else Id = Id + 1;
        }
        return Id;
    }

    const handleAddRule = () => {
        if (reglas.length < 3) {
            setReglas((prevReglas) => {
                const nuevasReglas = [...prevReglas];
                if (nuevasReglas.length > 0) {
                    nuevasReglas[nuevasReglas.length - 1] = {
                        ...nuevasReglas[nuevasReglas.length - 1],
                        operador: "and"
                    };
                }
                nuevasReglas.push({
                    id: giveNewID(),
                    tipoRegla: "",
                    configuracion: "",
                    campoTexto: "",
                    operador: "",
                    range: ""
                });
                return nuevasReglas;
            });
            alertify.notify("Rule added", "success", 5);
        } else {
            alertify.notify("Only three rules per parameter are allowed", "error", 5);
        }
    };

    const handleSelectAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = true);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = true;
                });
            }
            else if (selectedFunction === "Portfolios") {
                dataPortfolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = true;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = true;
                });
            }
            return newState;
        });
    };

    const handleClearAll = () => {
        setCheckboxes((prev) => {
            const newState = { ...prev };
            if (selectedFunction === "Adgroups") {
                dataAdgroups.forEach((campaign) => {
                    campaign.adGroups.forEach((adgroup) => newState[adgroup.adGroupId] = false);
                });
            }
            else if (selectedFunction === "Campaigns") {
                dataCampaign.forEach((campaign) => {
                    newState[campaign.campaignId] = false;
                });
            }
            else if (selectedFunction === "Portfolios") {
                dataPortfolios.forEach((portafolio) => {
                    newState[portafolio.portfolioId] = false;
                });
            }
            else if (selectedFunction === "Asins") {
                dataProductos.forEach((producto) => {
                    newState[producto.adId] = false;
                });
            }
            return newState;
        });
    };

    const toggleOpen = (itemId) => setIsOpen((prev) => ({ ...prev, [itemId]: !prev[itemId] }));

    const handleCheckboxChange = (id) => {
        setCheckboxes((prev) => {
            return {
                ...prev,
                [id]: !prev[id]
            };
        });
    };

    const handleFunctionSelect = (option) => {
        if (selectedFunction === "Select" || selectedFunction.trim() === "")
            changeDestination(option);
        else
            alertify.confirm("Destination change", "Current destination checkboxes will be lost. Do you want to continue", () => {
                changeDestination(option);
            }, () => alertify.error("Operation cancelled"));
    };

    const changeDestination = (option) => {
        setSelectedFunction(option);
        setShowForm(true);
        setShowDropdown(false);
        setTituloInformacion(option);
        setCheckboxes({});
    };

    const handleSectionSelect = (sectionName) => setSelectedSection(sectionName);

    useEffect(() => {
        if (!copiesRealTime || (!copiesRealTime.campaigns && !copiesRealTime.portafolios && !copiesRealTime.productos)) {
            setDataAdgroups([]);
            setDataCampaign([]);
            setDataPortfolios([]);
            setDataProductos([]);
            return;
        }

        const campaignMatchesType = (campaign) => campaign.type === selectedCampaignType;
        const textMatcher = (name) => name && name.toLowerCase().includes(searchText.toLowerCase());

        if (selectedFunction === "Adgroups") {
            let resultAdgroups = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : []; //

            resultAdgroups = resultAdgroups.filter(campaignMatchesType); //

            if (statusFilter !== "ALL") {
                resultAdgroups = resultAdgroups.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => adgroup.state === statusFilter) //
                })).filter(campaign => campaign.adGroups.length > 0); //
            }

            if (searchText.trim() !== "") {
                resultAdgroups = resultAdgroups.map(campaign => ({
                    ...campaign,
                    adGroups: campaign.adGroups.filter(adgroup => textMatcher(adgroup.name)) //
                })).filter(campaign => campaign.adGroups.length > 0); //
            }
            setDataAdgroups(resultAdgroups); //

        } else if (selectedFunction === "Campaigns") {
            let resultCampaigns = copiesRealTime.campaigns ? [...copiesRealTime.campaigns] : []; //

            resultCampaigns = resultCampaigns.filter(campaignMatchesType); //

            if (statusFilter !== "ALL") {
                resultCampaigns = resultCampaigns.filter(campaign => campaign.state === statusFilter); //
            }

            if (searchText.trim() !== "") {
                resultCampaigns = resultCampaigns.filter(campaign => textMatcher(campaign.name)); //
            }
            setDataCampaign(resultCampaigns); //

        } else if (selectedFunction === "Portfolios") {
            let resultPortfolios = copiesRealTime.portafolios ? [...copiesRealTime.portafolios] : []; //

            if (statusFilter !== "ALL") {
                resultPortfolios = resultPortfolios.filter(portafolio => portafolio.state === statusFilter); //
            }

            if (searchText.trim() !== "") {
                resultPortfolios = resultPortfolios.filter(portafolio => textMatcher(portafolio.name || "No Portfolio")); //
            }
            setDataPortfolios(resultPortfolios);

        } else if (selectedFunction === "Asins") {
            let resultProductos = copiesRealTime.productos ? [...copiesRealTime.productos] : []; //

            if (statusFilter === "ENABLED" || statusFilter === "PAUSED") {
                alertify.notify("ASINs do not have a State attribute", "warning", 5); //
            }

            if (searchText.trim() !== "") {
                resultProductos = resultProductos.filter(asin => textMatcher(asin.asin || "No ASIN")); //
            }
            setDataProductos(resultProductos); //

        } else {
            const baseCampaigns = copiesRealTime.campaigns ? copiesRealTime.campaigns.filter(campaignMatchesType) : [];
            setDataAdgroups(baseCampaigns.map(c => ({ ...c, adGroups: c.adGroups || [] })));
            setDataCampaign(baseCampaigns); //
            setDataPortfolios(copiesRealTime.portafolios || []);
            setDataProductos(copiesRealTime.productos || []);
        }

    }, [
        copiesRealTime,
        searchText,
        statusFilter,
        selectedFunction,
        selectedCampaignType,
        setDataAdgroups, //
        setDataCampaign, //
        setDataPortfolios, //
        setDataProductos //
    ]);

    return (
        <Layout>
            <div className="contenedor-principal">
                <main className="row px-0 mx-0">
                    <div className="col-12 col-lg-7 px-1 py-3 bg-white border border-2 border-dark">
                        <div className="container-fluid">
                            <h3 className="fs-3 text-center my-3">Parameter Creation</h3>
                            <div className="filtros-superiores my-5">
                                <div className="grupo-filtro1 mx-2 flex-column">
                                    <label className="mt-2 fs-6" htmlFor="destination-select">Destination:</label>
                                    <select
                                        id="destination-select"
                                        className="form-select"
                                        value={selectedFunction}
                                        onChange={(e) => { handleFunctionSelect(e.target.value) }}
                                    >
                                        <option value="">Select an option</option>
                                        <option value="Adgroups">Adgroups</option>
                                        <option value="Campaigns">Campaigns</option>
                                        <option value="Portfolios">Portfolios</option>
                                        <option value="Asins">Asins</option>
                                    </select>
                                </div>
                                <div className="grupo-filtro1 mx-2 flex-column">
                                    <label className="mt-2 fs-6" htmlFor="campaign-type-select">Sponsored Type:</label>
                                    <select
                                        id="campaign-type-select"
                                        className="form-select"
                                        value={selectedCampaignType}
                                        onChange={(e) => {
                                            const nuevoTipo = e.target.value;
                                            const hayChecks = Object.values(checkboxes).some((v) => v === true);
                                            if (hayChecks) {
                                                alertify.confirm(
                                                    "Sponsored Type change",
                                                    "Current selections will be lost. Do you want to continue",
                                                    () => {
                                                        setSelectedCampaignType(nuevoTipo);
                                                        setCheckboxes({});
                                                    },
                                                    () => alertify.error("Operation cancelled")
                                                );
                                            } else {
                                                setSelectedCampaignType(nuevoTipo);
                                                setCheckboxes({});
                                            }
                                        }}
                                    >

                                        <option value="SP">Sponsored Products (SP)</option>
                                        <option value="SB">Sponsored Brands (SB)</option>
                                    </select>
                                </div>

                                <div className="grupo-filtro2 mx-2 flex-column">
                                    <label className="mt-2 fs-6" htmlFor="section-select">Section:</label>
                                    <select
                                        id="section-select"
                                        className="form-select"
                                        value={selectedSection}
                                        onChange={(e) => handleSectionSelect(e.target.value)}
                                    >
                                        <option value="">Select an option</option>
                                        <option value="RISK">RISK</option>
                                        <option value="NEUTRAL">NEUTRAL</option>
                                        <option value="SECURE">SECURE</option>
                                    </select>
                                </div>
                            </div>
                            {showForm && (
                                <div className="row">
                                    <div className="col-12 mb-3">
                                        <label className="fs-5">Parameter Name:</label>
                                    </div>
                                    <div className="col-6">
                                        <input id="name_new_item" className="input-form-text " type="text" placeholder="Enter a Name" />
                                    </div>
                                    <div className="col-6">
                                        <button className="btn btn-primary" onClick={handleAddRule}>
                                            <i className="bi bi-plus"></i>Add Rule
                                        </button>
                                    </div>
                                </div>
                            )}
                            <div className="mt-5">
                                {reglas.map((regla, index) => (
                                    <React.Fragment key={regla.id}>
                                        <div className="regla-container border rounded p-3 mb-3">
                                            <h5 className="my-3">Rule: R{index + 1}</h5>

                                            <div className="row mb-2">
                                                <div className="col-md-6">Rule Type:</div>
                                                <div className="col-md-6">
                                                    <select
                                                        className="form-select"
                                                        value={regla.tipoRegla}
                                                        onChange={(e) =>
                                                            actualizarRegla(regla.id, "tipoRegla", e.target.value)
                                                        }
                                                    >
                                                        <option value="">Select</option>
                                                        <option value="Textual">Text</option>
                                                        <option value="Numeric">Numeric</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="row mb-2">
                                                <div className="col-md-6">Configuration:</div>
                                                <div className="col-md-6">
                                                    <select
                                                        className="form-select"
                                                        value={regla.configuracion}
                                                        onChange={(e) =>
                                                            actualizarRegla(regla.id, "configuracion", e.target.value)
                                                        }
                                                    >
                                                        <option value="">Select</option>
                                                        {regla.tipoRegla === "Numeric" ? (
                                                            <>
                                                                <option value="Impresiones">Impressions</option>
                                                                <option value="Clicks">Clicks</option>

                                                                {(selectedCampaignType === "SP") && (
                                                                    <>
                                                                        <option value="7d Total Sales">7d Total Sales</option>
                                                                        <option value="7d Total Orders">7d Total Orders</option>
                                                                        <option value="Click-Thru Rate">Click-Thru Rate</option>
                                                                        <option value="ACOS">ACOS</option>
                                                                        <option value="ROAS">ROAS</option>
                                                                    </>
                                                                )}

                                                                {(selectedCampaignType === "SB") && (
                                                                    <>
                                                                        <option value="View Click Through Rate">View Click Through Rate</option>
                                                                    </>
                                                                )}

                                                                <option value="Spend">Spend</option>
                                                                <option value="Cost per Click">Cost per Click</option>

                                                            </>
                                                        ) : (
                                                            <>
                                                                <option value="Contains">Contains</option>
                                                                <option value="No Contains">Does Not Contain</option>
                                                                <option value="Equals">Equals</option>
                                                                <option value="Not Equal to">Not Equal to</option>
                                                                <option value="Starts with">Starts with</option>
                                                                <option value="Ends with">Ends with</option>
                                                            </>
                                                        )}
                                                    </select>
                                                </div>
                                            </div>

                                            {regla.tipoRegla === "Numeric" && (
                                                <div className="row mb-2">
                                                    <div className="col-md-6">Range:</div>
                                                    <div className="col-md-6">
                                                        <select
                                                            className="form-select"
                                                            value={regla.range}
                                                            onChange={(e) =>
                                                                actualizarRegla(regla.id, "range", e.target.value)
                                                            }
                                                        >
                                                            <option value="">Select</option>
                                                            <option value="Greater than">Greater than</option>
                                                            <option value="Equal to">Equal to</option>
                                                            <option value="Less than">Less than</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="row mb-2">
                                                <div className="col-md-6">
                                                    {regla.tipoRegla === "Textual" ? "Text : " : "Number:"}
                                                </div>
                                                <div className="col-md-6">
                                                    <input
                                                        className="form-control"
                                                        value={regla.campoTexto}
                                                        onChange={(e) =>
                                                            actualizarRegla(regla.id, "campoTexto", e.target.value)
                                                        }
                                                        type={regla.tipoRegla === "Numeric" ? "number" : "text"}
                                                    />
                                                </div>
                                            </div>

                                            <div className="text-end">
                                                <button
                                                    className="btn btn-danger btn-sm my-3"
                                                    onClick={() => handleDeleteRegla(regla.id)}
                                                >
                                                    Delete
                                                </button>
                                            </div>
                                        </div>

                                        {index < reglas.length - 1 && (
                                            <div className="mb-4 d-flex justify-content-center align-items-center">
                                                <label className="me-3">
                                                    <input
                                                        type="radio"
                                                        value="and"
                                                        className="form-check-input border border-1 border-dark mx-2"
                                                        checked={regla.operador === "and"}
                                                        onChange={() =>
                                                            actualizarRegla(regla.id, "operador", "and")
                                                        }
                                                    />
                                                    AND
                                                </label>
                                                <label>
                                                    <input
                                                        type="radio"
                                                        value="or"
                                                        className="form-check-input border border-1 border-dark mx-2"
                                                        checked={regla.operador === "or"}
                                                        onChange={() =>
                                                            actualizarRegla(regla.id, "operador", "or")
                                                        }
                                                    />
                                                    OR
                                                </label>
                                            </div>
                                        )}
                                    </React.Fragment>
                                ))}

                            </div>
                            <div className="grupo-botones mt-5">
                                <button
                                    className="btn btn-success"
                                    onClick={() => setShowSaveModal(true)}
                                >
                                    Save
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowCancelModal(true)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-5 p-3 bg-white border border-2 border-dark">
                        <div className="row">
                            <div className="col-6">
                                <input
                                    id="submenuInput"
                                    type="text"
                                    className="form-control w-100"
                                    placeholder="Search..."
                                    value={searchText}
                                    onChange={(e) => setSearchText(e.target.value)}
                                />

                            </div>
                            <div className="col-6">
                                <div className="dropdown w-auto">
                                    <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        Filter by
                                    </button>
                                    <ul className="dropdown-menu px-2 py-2">
                                        <li className="mx-1 my-2" style={{ cursor: "pointer" }} onClick={() => handleFilterClick("ENABLED")}>State Enabled</li>
                                        <li className="mx-1 my-2" style={{ cursor: "pointer" }} onClick={() => handleFilterClick("PAUSED")}>State Paused</li>
                                        <li className="mx-1 my-2" style={{ cursor: "pointer" }} onClick={() => handleFilterClick("ALL")}>No Filter</li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <h3 className="my-3">{tituloInformacion}</h3>
                        {selectedFunction !== "Select" && (
                            <div className="checkbox-actions1">
                                <button
                                    className="btn btn-secondary mx-2 my-2"
                                    onClick={handleSelectAll}
                                >
                                    Select all
                                </button>
                                <button
                                    className="btn btn-danger mx-2 my-2"
                                    onClick={handleClearAll}
                                >
                                    Clear all
                                </button>
                            </div>
                        )}

                        {(selectedFunction === "Adgroups" ? dataAdgroups : [])
                            .map((campaign, idx) => (
                                <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>
                                    <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(campaign.campaignId)}
                                    >
                                        <span className="float-start">
                                            {isOpen[campaign.campaignId] ? "v " : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                            Campaign: {campaign.name.replaceAll("_", " ")}
                                        </span>
                                        <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                            State: {campaign.state} <br />
                                            Type: {campaign.type}
                                        </span>

                                    </button>
                                    {isOpen[campaign.campaignId] && (
                                        <div className="adgroup-options">
                                            {campaign.adGroups.map((adgroup, index) => (
                                                <div key={`adgroup-${adgroup.adGroupId}-${index}`}
                                                    className="form-control d-flex align-items-center justify-content-evenly">
                                                    <input type="checkbox" className="mx-3" checked={
                                                        checkboxes[adgroup.adGroupId] || false} onChange={() =>
                                                            handleCheckboxChange(adgroup.adGroupId)}
                                                        id={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}
                                                    />
                                                    <label style={{ fontSize: "14px" }} htmlFor={`adgroup-${campaign.campaignId}-${adgroup.adGroupId}-${index}`}>
                                                        AdGroup: {adgroup.name.replaceAll("_", " ")}
                                                    </label>
                                                    <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>Status: {adgroup.state}</span>
                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )
                            )}

                        {(selectedFunction === "Campaigns" ? dataCampaign : [])
                            .map((campaign, idx) => (
                                <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>

                                    <div className="row px-0 mx-0">
                                        <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={checkboxes[campaign.campaignId] || false}
                                                onChange={() => handleCheckboxChange(campaign.campaignId)}
                                                className="form-check-input h-50 w-100 border border-1 border-dark"
                                            />
                                        </div>
                                        <div className="col-11">
                                            <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(campaign.campaignId)}
                                            >
                                                <span className="float-start">
                                                    {isOpen[campaign.campaignId] ? "v " : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                    Campaign: {campaign.name.replaceAll("_", " ")}
                                                </span>
                                                <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                    State: {campaign.state} <br />
                                                    Type: {campaign.type}
                                                </span>

                                            </button>
                                        </div>
                                        <div className="col-12">
                                            {isOpen[campaign.campaignId] && (
                                                <div className="adgroup-options">
                                                    {campaign.adGroups.map((adgroup, index) => (
                                                        <div key={`adgroup-${adgroup.adGroupId}-${index}`}
                                                            className="form-control d-flex align-items-center justify-content-evenly">
                                                            <label style={{ fontSize: "14px" }}>
                                                                AdGroup: {adgroup.name.replaceAll("_", " ")}
                                                            </label>
                                                            <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>Status: {adgroup.state}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                            )}

                        {(selectedFunction === "Portfolios" ? dataPortfolios : [])
                            .map((portafolio, idx) => (
                                <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>
                                    <div className="row px-0 mx-0">
                                        <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={checkboxes[portafolio.portfolioId] || false}
                                                onChange={() => handleCheckboxChange(portafolio.portfolioId)}
                                                className="form-check-input h-50 w-100 border border-1 border-dark"
                                            />
                                        </div>
                                        <div className="col-11">
                                            <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(portafolio.portfolioId)}
                                            >
                                                <span className="float-start">
                                                    {isOpen[portafolio.portfolioId] ? "v " : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                    Portfolio: {portafolio.name.replaceAll("_", " ")}
                                                </span>
                                                <span className="float-end text-light" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                    State: {portafolio.state} <br />
                                                </span>
                                            </button>
                                        </div>
                                        <div className="col-12">
                                            {isOpen[portafolio.portfolioId] && (
                                                <div className="adgroup-options">
                                                    {portafolio.campaigns.map((campaign, index) => (
                                                        <div key={`campaign-${campaign.campaignId}-${index}`}
                                                            className="form-control d-flex align-items-center justify-content-evenly">
                                                            <label style={{ fontSize: "14px" }}>
                                                                Campaign: {campaign.name.replaceAll("_", " ")}
                                                            </label>
                                                            <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                                Status: {campaign.state}<br />
                                                                Type: {campaign.type}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                            )}

                        {(selectedFunction === "Asins" ? dataProductos : [])
                            .map((producto, idx) => (
                                <div className="campaign-container" style={{ overflow: "auto", height: "300px", }} key={idx}>

                                    <div className="row px-0 mx-0">
                                        <div className="col-1 px-0 d-flex justify-content-center align-items-center">
                                            <input
                                                type="checkbox"
                                                checked={checkboxes[producto.adId] || false}
                                                onChange={() => handleCheckboxChange(producto.adId)}
                                                className="form-check-input h-50 w-100 border border-1 border-dark"
                                            />
                                        </div>
                                        <div className="col-11">
                                            <button className="btn btn-success w-100 text-center d-flex justify-content-evenly align-items-center" onClick={() => toggleOpen(producto.adId)}
                                            >
                                                <span className="float-start">
                                                    {isOpen[producto.adId] ? "v " : <FontAwesomeIcon className="me-2" icon={faPlay} />}
                                                    ASIN: {typeof producto.asin === 'string' && producto.asin.trim() !== '' ? producto.asin.replaceAll("_", " ") : "ASIN unnamed"}
                                                </span>
                                            </button>
                                        </div>
                                        <div className="col-12">
                                            {isOpen[producto.adId] && (
                                                <div className="adgroup-options">
                                                    {producto.campaigns.map((campaign, index) => (
                                                        <div key={`campaign-${campaign.campaignId}-${index}`}
                                                            className="form-control d-flex align-items-center justify-content-evenly">
                                                            <label style={{ fontSize: "14px" }}>
                                                                Campaign: {campaign.name.replaceAll("_", " ")}
                                                            </label>
                                                            <span className="float-end" style={{ fontSize: "11px", textTransform: "uppercase" }}>
                                                                Status: {campaign.state}<br />
                                                                Type: {campaign.type}
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            )
                            )}

                    </div>
                </main >
                {showSaveModal && (
                    <div className="modal1-overlay">
                        <div className="modal1">
                            <label className="fs-4 text-center my-3">Do you want to save the created parameter</label>
                            <div className="modal1-buttons">
                                <button className="btn btn-success" onClick={handleSave}>
                                    Yes, save
                                </button>
                                <button
                                    className="btn btn-danger"
                                    onClick={() => setShowSaveModal(false)}
                                >
                                    No, cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                {
                    showCancelModal && (
                        <div className="modal1-overlay">
                            <div className="modal1">
                                <label className="fs-4 text-center my-3">
                                    Are you sure you want to cancel the parameter creation
                                </label>
                                <div className="modal1-buttons">
                                    <button className="btn btn-success" onClick={handleCancel}>
                                        Yes, cancel
                                    </button>
                                    <button
                                        className="btn btn-danger"
                                        onClick={() => setShowCancelModal(false)}
                                    >
                                        No, continue
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                }
            </div >
        </Layout>
    );
};

export default AddParameters;
